module.exports = __webpack_public_path__ + "static/media/hang-up-icon.bc9ee56b.svg";